// extracted by mini-css-extract-plugin
export default {"backgrop":"backdrop_backgrop__dbc8p","backgrop-hidden":"backdrop_backgrop-hidden__0Moqz"};